import React, { useState } from "react";
import { IoFilter } from "react-icons/io5";
import { MdOutlineFilterListOff, MdOutlineMonitor } from "react-icons/md";
import { useHistory } from "react-router-dom";
import {
  useFilterCheckin,
  type FilterCheckinContextValue,
} from "context/FilterCheckinContext";
import FilterContent from "../FilterContent";

import * as S from "./styles";

interface Props {
  data: any;
}

const FilterButtons: React.FC<Props> = (props) => {
  const history = useHistory();
  const { limparFilterCheckin, activeFilterCount }: FilterCheckinContextValue =
    useFilterCheckin();
  const [filtersOpen, setFiltersOpen] = useState<boolean>(false);

  const handleClearFilters = () => {
    limparFilterCheckin();
  };

  const handleNavigate = (id: string) => {
    history.push(`/roleta-ao-vivo/${id}`);
  };

  return (
    <S.Container>
      {!props?.data?.corretor && props?.data?.checkins[0]?.aoVivo ? (
        <S.Button
          onClick={() =>
            handleNavigate(props?.data?.checkins[0]?.idRoletaCheckin)
          }
        >
          <MdOutlineMonitor />
          Roleta ao vivo
        </S.Button>
      ) : null}
      <S.FilterButton onClick={() => setFiltersOpen(true)}>
        <IoFilter />
        Filtrar
      </S.FilterButton>
      <S.FilterButtonOutline onClick={handleClearFilters}>
        <MdOutlineFilterListOff />
        {activeFilterCount > 0 ? (
          <S.Badge>
            <p>{activeFilterCount}</p>
          </S.Badge>
        ) : null}
      </S.FilterButtonOutline>

      <S.SwipeableDrawer
        open={filtersOpen}
        anchor="right"
        onClose={() => setFiltersOpen(false)}
        onOpen={() => setFiltersOpen(true)}
      >
        <FilterContent
          onCloseModal={() => setFiltersOpen(false)}
          data={props.data}
          isOpen={filtersOpen}
        />
      </S.SwipeableDrawer>
    </S.Container>
  );
};

export default FilterButtons;
